<div class="sticky-bar int-sticky-bar">
  <ul>
    <li>
      <a
        href="https://api.whatsapp.com/send/?phone=917774008603&amp;text=Hi, I need assistance for Admission at your RGI Institutions for Academic Year 2026-27"
        target="_blank"
      >
        <div class="icon"><i class="fa fa-whatsapp"></i></div>
        <div class="st-label">Whatsapp Chat</div>
      </a>
    </li>
    <!-- <li>
          <a href="mailto:admissions@raisoni.net">
              <div class="icon"><i class="fa fa-envelope"></i></div>
              <div class="st-label">Mail Us</div>
          </a>
      </li> -->

    <li>
      <a href="https://raisoni.nopaperforms.com/rgi" target="_blank">
        <div class="icon"><i class="fa fa-edit"></i></div>
        <div class="st-label">Apply Now</div>
      </a>
    </li>
  </ul>
</div>

<button class="trigger_popup" id="myBtn">Enquire Now</button>
<div
  id="myModal"
  class="enquiry-modal"
  data-backdrop="static"
  data-keyboard="false"
  style="display: none"
>
  <div class="modal-content">
    <div class="head_text">Enquire Now</div>
    <button
      class="close"
      onclick="document.getElementById('myModal').style.display='none'"
    >
      &times;
    </button>
    <div
      class="npf_wgts"
      data-height="480px"
      data-w="5ac66c069923a6ba49784ed2f69cd313"
    >
      <iframe
        frameborder="0"
        width="100%"
        height="480px"
        sandbox="allow-top-navigation allow-scripts allow-same-origin"
        src="https://widgets.nopaperforms.com/register?&amp;r=&amp;q=&amp;w=6e2d938a8f42987637737ee22606670f&amp;m=&amp;cu=https://www.raisoni.net/media/photo-gallery/"
      ></iframe>
    </div>
  </div>
</div>

<div class="modal fade" id="adm-modal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body text-center">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
        >
          ×
        </button>
        <div class="admission-modal">
          <img
            src="assets/images/admission.webp"
            alt="Admission- 2021 | Ghrcacsn"
            title="Admission- 2021 | Ghrcacsn"
            class="img-fluid"
          />
          <div class="adm-info mt-3">
            <h5>Admission- 2022 Live Video Counselling</h5>
            <h5>(One to One Interaction)</h5>
            <p>
              Interact with expert Admission Counsellors through live video
              counselling for career guidance to discover one's best-suited
              programme/ stream from 10 am to 6 pm on all working days except
              for Sundays
            </p>
            <div class="text-center mt-3">
              <a
                class="button-text"
                href="https://ghraisoni.webex.com/webappng/sites/ghraisoni/dashboard?siteurl=ghraisoni&viewSwitch=c2m"
                target="_blank"
                >Read More</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
